import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvisorsTreeFilterComponent } from './advisors-tree-filter.component';
import { SharedModule } from '../shared.module';
@NgModule({
  declarations: [
    AdvisorsTreeFilterComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [AdvisorsTreeFilterComponent], 
})
export class AdvisorsTreeFilterModule { }
